import React from "react";
import HomieContext from "HomieContext";
import { RedirectNewError404 } from "./RedirectNewError404";
import styled from "styled-components";

const HiddenOldPage = styled.div`
  height: 100vh;
  background: #fff;
  width: 100vw;
  margin: 0px;
  padding: 0px;
  position: absolute;
  z-index: 100;
  max-width: 100vw;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;

class PageNotFound extends React.Component {
  render() {
    return (
      <HiddenOldPage>
        <RedirectNewError404 />
      </HiddenOldPage>
    );
  }
}

PageNotFound.contextType = HomieContext;

export default PageNotFound;
